import { Box } from '@mui/material'
import { useContext } from 'react'

// others
import { useDeleteOfficeMutation } from '../../../generated'
import { NOT_APPLICABLE } from '../../constants'
import { AppContext } from '../../context'
import { ActionType } from '../../context/AppContextReducer'
import { OfficeMenuProps } from '../../interfaceTypes/props'

// components
import { Alert } from '../common/Alert'
import CustomMenu from '../common/CustomMenu'
import { DeleteModalContent } from '../common/DeleteModalContent'
import OfficeModal from '../offices/OfficeModal'

const OfficeMenu = ({ office, refetch }: OfficeMenuProps) => {
  const { dispatch, isOpen } = useContext(AppContext)

  const [deleteOffice, { loading: deleting }] = useDeleteOfficeMutation({
    onError: error => {
      Alert.error(`Profit Center couldn't be deleted due to: ${error.message}`)
    },
    onCompleted: () => {
      dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })
      Alert.success('Profit Center deleted successfully')
      refetch()
    }
  })

  const onDeleteOffice = async (officeId: string) =>
    await deleteOffice({ variables: { deleteOfficeId: office.id, addressId: office.addresses?.[0]?.id || '' } })

  return (
    <CustomMenu
      id={office?.id.toString() || ''}
      menuTitle="Profit Center"
      onDelete={onDeleteOffice}
      deleteContent={
        <Box mt={1}>
          <DeleteModalContent label="ID" value={office.id.toString() || NOT_APPLICABLE} />
          <DeleteModalContent label="Name" value={office.name || NOT_APPLICABLE} />
        </Box>
      }
      deleting={deleting}
      modal={
        <OfficeModal
          handleClose={() => dispatch({ type: ActionType.SET_IS_OPEN, isOpen: false })}
          isOpen={isOpen}
          refetch={refetch}
          office={office}
        />
      }
    />
  )
}

export default OfficeMenu
